import { MatButtonCustomised } from 'components/mat-theme/button'
import React from 'react'

type MatButtonInterface = {
    id: string
    children: React.ReactNode
    variant: 'text' | 'contained' | 'outlined'
    onClick?: React.MouseEventHandler<HTMLButtonElement>
    color?: 'warning' | 'primary' | 'secondary' | 'inherit' | 'success' | 'error' | 'info'
    size?: 'small' | 'medium' | 'large'
    disabled?: boolean
    className?: string
    endIcon?: React.ReactNode
    startIcon?: React.ReactNode
    height?: string
    width?: string
    borderRadius?: string
}

const MatButton: React.FC<MatButtonInterface> = ({
    onClick,
    children,
    id,
    variant,
    color,
    size = 'medium',
    className = '',
    disabled = false,
    endIcon = undefined,
    startIcon = undefined,
    height = undefined,
    width = undefined,
    borderRadius = undefined
}) => {
    return (
        <MatButtonCustomised
            id={id}
            size={size}
            color={color}
            onClick={onClick}
            disabled={disabled}
            variant={variant}
            className={className}
            startIcon={startIcon}
            endIcon={endIcon}
            height={height}
            width={width}
            borderRadius={borderRadius}
        >
            {children}
        </MatButtonCustomised>
    )
}
export { MatButton }
export type { MatButtonInterface }
